export default class ServiceDetailSwitch {
  constructor() {
    const toggles = document.querySelectorAll(".js-service-sidebar-toggle");
    if (!toggles.length) return;

    toggles.forEach((toggleEl) => {
      const root = toggleEl.closest(".service-detail__mobile-switch");
      if (!root) return;
      const menu = root.querySelector(".js-service-sidebar-menu");
      if (!menu) return;

      const closeMenu = () => {
        menu.hidden = true;
        toggleEl.classList.remove("is-open");
        toggleEl.setAttribute("aria-expanded", "false");
      };

      const openMenu = () => {
        menu.hidden = false;
        toggleEl.classList.add("is-open");
        toggleEl.setAttribute("aria-expanded", "true");
      };

      toggleEl.addEventListener("click", () => {
        if (menu.hidden) openMenu();
        else closeMenu();
      });

      document.addEventListener("click", (event) => {
        if (!root.contains(event.target)) closeMenu();
      });

      const MQ = 768;
      const onResize = () => {
        if (window.innerWidth >= MQ) closeMenu();
      };
      window.addEventListener("resize", onResize);
    });
  }
}
